export function isAdminMitra(user) {
  const p = String((user && (user.peran || user.status)) || "")
    .toLowerCase()
    .trim();
  return p === "admin mitra";
}

export function getMitraLembagaId(user) {
  const id = user && user.id_lembaga;
  if (id == null || id === "") return null;
  const n = Number(id);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function isMitraAllowedPath(pathname) {
  const p = String(pathname || "");
  if (p.startsWith("/admin/nirlaba/lembaga")) return false;
  return (
    p.startsWith("/admin/nirlaba") ||
    p === "/template" ||
    p.startsWith("/template/dashboard") ||
    p.startsWith("/template/desil") ||
    p.startsWith("/template/user/profile") ||
    p.startsWith("/template/edit_profile") ||
    p.startsWith("/admin/profil")
  );
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch (e) {
    return null;
  }
}

export function filterRowsByMitraLembaga(rows, idField = "id_lembaga") {
  const user = getStoredUser();
  const lid = getMitraLembagaId(user);
  if (!isAdminMitra(user) || !lid) return rows || [];
  return (rows || []).filter((x) => Number(x[idField]) === lid);
}

export function getMitraQueryParams() {
  const user = getStoredUser();
  const lid = getMitraLembagaId(user);
  if (!isAdminMitra(user) || !lid) return {};
  return { id_lembaga: lid };
}
